import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuStatus: 0,
    taskId: 0,
    projectId: 0
  },
  mutations: {
    changeMenuStatus(state, payload) {
      console.log(payload.value, '值')
      state.menuStatus = payload.value
    },
    changeTaskId(state, payload) {
      console.log(payload.value, '值')
      state.taskId = payload.value
    },
    changeProjectId(state, payload) {
      console.log(payload.value, '值')
      state.projectId = payload.value
    }
  },
  actions: {
  },
  modules: {
    user,
    app
  },
  getters:{
    getMenuStatus(state){
      return state.menuStatus
    },
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    allMenu: state => state.user.allMenu,
    hasPermissionMenu: state => state.user.hasPermissionMenu,
  }
})
